// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table__Km5O_VH36y{table-layout:fixed;height:auto}.tableWrapper__qSgOP8YUlL{height:100%}`, "",{"version":3,"sources":["webpack://./src/assets/components/teamPageLegacy/teamPageTable.module.scss"],"names":[],"mappings":"AAEA,mBACE,kBAAA,CACA,WAAA,CAGF,0BACE,WAAA","sourcesContent":["@use 'common' as *;\n\n.table {\n  table-layout: fixed;\n  height: auto;\n}\n\n.tableWrapper {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table__Km5O_VH36y`,
	"tableWrapper": `tableWrapper__qSgOP8YUlL`
};
export default ___CSS_LOADER_EXPORT___;
